module.exports = __webpack_public_path__ + "img/20180414165855.6dee59da.jpg";